import login from './login';

const loginPlugin = {

  install(Vue) {
    Vue.prototype.$loginSparkPlugin = {
      // ==============入口模块===================
      entryPoint: () => { },
      // ==============登录模块================
      initLogin: login.initLogin,
      checkLogin: login.checkLogin,
      login: login.login,
      logout: login.logout,
    };
  },
};
export default loginPlugin;
